<template>
  <v-card elevation="2" outlined shaped tile class="my-4">
    <v-card-title>
      <div @click="expand = !expand" :style="{ cursor: 'pointer' }">Single Image</div>
      <div class="ml-2">
        <v-btn icon color="green" @click="moveUp(section.id)">
          <v-icon>mdi-arrow-up-bold-box</v-icon>
        </v-btn>
        <v-btn icon color="red" @click="moveDown(section.id)">
          <v-icon>mdi-arrow-down-bold-box</v-icon>
        </v-btn>
      </div>
    </v-card-title>
    <v-card-subtitle v-if="expand">
      <div>ID: {{ section.id }}</div>
      <div>Type: {{ section.type }}</div>
      <div>Sort Order: {{ section.sort_order }}</div>
      <div>Children Count: {{ section.children.length }}</div>
    </v-card-subtitle>
    <v-card-text v-if="expand">
      <div class="d-flex flex-wrap">
        <v-flex xs1>
          <img :src="selectIconImageBase64 || section.attributes.icon_url" class="mb-6" style="width: 100%" />
        </v-flex>
        <v-flex xs1 class="pl-4">
          <v-btn fab dark small color="cyan" elevation="1" @click="() => openImagePicker('icon')">
            <v-icon dark>edit</v-icon>
          </v-btn>
          <div class="mt-2">PNG no larger than 1MB</div>
        </v-flex>
        <v-flex xs4>
          <img :src="selectImageBase64 || section.attributes.image_url" class="mb-6" style="width: 100%" />
        </v-flex>
        <v-flex xs3 class="pl-4">
          <v-btn fab dark small color="cyan" elevation="1" @click="() => openImagePicker('image')">
            <v-icon dark>edit</v-icon>
          </v-btn>
          <div class="mt-2">PNG, JPG no larger than 1MB</div>
        </v-flex>
        <v-flex xs3></v-flex>
        <v-flex xs12 class="mt-2 mb-2">
          <v-text-field label="Title" v-model="section.title" dense></v-text-field>
        </v-flex>
        <v-flex xs12 class="mb-2">
          <v-text-field label="Subtitle" v-model="section.subtitle" dense></v-text-field>
        </v-flex>
        <v-flex xs12 class="mb-2">
          <v-text-field label="CTA Text" v-model="section.attributes.cta_text" dense></v-text-field>
        </v-flex>
        <v-flex xs12 class="mb-2">
          <v-text-field label="CTA Deeplink" v-model="section.attributes.cta_deeplink" dense></v-text-field>
        </v-flex>
      </div>
    </v-card-text>
    <v-card-actions v-if="expand">
      <v-btn color="primary" @click="save">Save</v-btn>
      <v-btn text color="error" @click="deleteSection(section.id)">Remove</v-btn>
    </v-card-actions>
    <input type="file" ref="imageInput" style="display: none" accept="image/*" @change="onSelectFile" />
  </v-card>
</template>

<script>
import { Vue } from 'vue-property-decorator';
import homefeedService from '../../../services/homefeed';
import { srcToBase64 } from '../../../utils/stringUtil';
export default Vue.extend({
  props: {
    section: {
      type: Object,
      required: true,
    },
    moveUp: {
      type: Function,
      required: true,
    },
    moveDown: {
      type: Function,
      required: true,
    },
    deleteSection: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      expand: false,
      currentImageType: null,
      selectIconImageFileName: null,
      selectIconImageBase64: null,
      selectImageFileName: null,
      selectImageBase64: null,
    };
  },
  methods: {
    openImagePicker(type) {
      this.currentImageType = type;
      this.$refs.imageInput.click();
    },
    onSelectFile(e) {
      const files = e.target.files;
      const file = files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (event) => {
          const base64String = event.target.result;

          if (this.currentImageType === 'icon') {
            this.selectIconImageFileName = file.name;
            this.selectIconImageBase64 = base64String;
          } else if (this.currentImageType === 'image') {
            this.selectImageFileName = file.name;
            this.selectImageBase64 = base64String;
          }
        };
        reader.onerror = (error) => {
          console.error('Error reading file:', error);
        };
        reader.readAsDataURL(file);
      } else {
        console.error('No file selected');
      }
    },
    async save() {
      const requestBody = {
        title: this.section.title,
        subtitle: this.section.subtitle,
        attributes: {
          cta_text: this.section.attributes.cta_text,
          cta_deeplink: this.section.attributes.cta_deeplink,
        },
      };

      if (this.selectImageBase64) {
        requestBody.attributes.image_url = {
          image_base64: srcToBase64(this.selectImageBase64),
          image_filename: this.selectImageFileName,
        };
      }

      if (this.selectIconImageBase64) {
        requestBody.attributes.icon_url = {
          image_base64: srcToBase64(this.selectIconImageBase64),
          image_filename: this.selectIconImageFileName,
        };
      }

      await homefeedService.updateSection(this.section.id, requestBody);
      console.log('Successfully updated section ID:', this.section.id);
    },
  },
});
</script>

<style scoped></style>
